<template>
    <blank-layout>

        <JiraGetStarted v-if="integration_type == 'jira'" class="-mt-6 flex flex-grow flex-col"
            :integration="integration"></JiraGetStarted>

        <div v-else class="-mt-6 flex flex-grow flex-col">

            <div class="flex flex-col md:flex-row w-full flex-grow">



                <div class="flex flex-grow bg-white flex-col justify-center items-center">


                    <div class="flex flex-col w-full max-w-xl">


                        <div v-if="integration_type == 'intercom'">
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-5">
                                <img src="/img/logo-black-website.svg" width="190" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-1 uppercase">+</span>
                                <img src="/img/intercom-full-dark.svg" width="230" alt="Logo" class="" />
                            </h3>
                        </div>
                        <div v-else-if="integration_type == 'aircall'">
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-5">
                                <img src="/img/logo-black-website.svg" width="190" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-1 uppercase">+</span>
                                <img src="/img/aircall_logo.svg" width="200" alt="Logo" class="" />
                            </h3>
                        </div>
                        <div v-else-if="integration_type == 'zendesk'">
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-5">
                                <img src="/img/logo-black-website.svg" width="190" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-1 uppercase">+</span>
                                <img src="/img/zendesk-full-dark.svg" width="200" alt="Logo" class="mb-1" />
                            </h3>
                        </div>
                        <div v-else-if="integration_type == 'helpscout'">
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-5">
                                <img src="/img/logo-black-website.svg" width="190" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-1 uppercase">+</span>
                                <img src="/img/helpscout-logo.svg" width="200" alt="Logo" class="" />
                            </h3>
                        </div>
                        <div v-else-if="integration_type == 'freshchat'">
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-5">
                                <img src="/img/logo-black-website.svg" width="190" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-1 uppercase">+</span>
                                <img src="/img/freshchat-logo.svg" width="200" alt="Logo" class="" />
                            </h3>
                        </div>
                        <div v-else-if="integration_type == 'freshdesk'">
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-5">
                                <img src="/img/logo-black-website.svg" width="190" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-1 uppercase">+</span>
                                <img src="/img/freshdesk-logo.svg" width="200" alt="Logo" class="" />
                            </h3>
                        </div>
                        <div v-else-if="integration_type == 'jira'">
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-5">
                                <img src="/img/logo-black-website.svg" width="160" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-1 uppercase">+</span>
                                <img src="/img/jsm-logo.svg" width="40" alt="Logo" class="" />
                            </h3>
                        </div>
                        <div v-else-if="integration_type == 'salesforce'">
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-5">
                                <img src="/img/logo-black-website.svg" width="160" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-1 uppercase">+</span>
                                <img src="/img/salesforce_blue_logo.svg" width="90" alt="Logo" class="" />
                            </h3>
                        </div>
                        <div v-else-if="integration_type == 'hubspot'">
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-5">
                                <img src="/img/logo-black-website.svg" width="160" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-1 uppercase">+</span>
                                <img src="/img/hubspot_full.svg" width="170" alt="Logo" class="" />
                            </h3>
                        </div>
                        <h1 v-if="redirect" class="text-center text-2xl mt-3 text-gray-700">Link Birdie with Aircall
                        </h1>
                        <h1 v-else class="text-center text-2xl mt-3 text-gray-700">Get started with Birdie</h1>

                        <p>&nbsp;</p>

                        <div v-if="redirect" class="text-center">


                            <a :href="redirect" type="button"
                                class="inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 disabled:cursor-default transition bg-blue-500 hover:bg-blue-400">
                                Go to Aircall <vue-feather type="arrow-right" class="h-4 w-4 ml-2" />
                            </a>

                        </div>

                        <jet-form v-else @submitted="submitInstall">

                            <template #form>

                                <div class="flex flex-row">
                                    <jet-label for="email" value="Email"
                                        class="text-xl text-gray-600 font-bold self-center" />

                                    <jet-input id="email" type="email" class="mx-3 block flex-grow" v-model="form.email"
                                        ref="email" autocomplete="email" placeholder="john@empire.com" />


                                    <jet-input-error :message="form.errors.email" class="mt-2" />

                                    <jet-button class="bg-blue-500 text-white hover:bg-blue-400"
                                        :class="{ 'opacity-25': form.processing }"
                                        :disabled="form.processing || !is_complete">
                                        Next <vue-feather type="arrow-right" class="h-4 w-4 ml-2" />
                                    </jet-button>

                                </div>

                                <div class="flex flex-row">
                                    <jet-label for="#" value="Email"
                                        class="text-xl text-white font-bold self-center opacity-0 pointer-events-none" />
                                    <div class="inline-flex flex-col ">
                                        <div class="text-sm text-blue-500 mx-3 mt-2 text-left">
                                            Already have a Birdie account? Use that email here.
                                        </div>
                                    </div>

                                </div>

                                <!-- <div class="text-sm text-blue-500 mt-2 text-center">
                                    Already have a Birdie account? Use that email here.
                                </div> -->

                            </template>

                        </jet-form>


                    </div>


                </div>


            </div>


        </div>

    </blank-layout>
</template>

<script>

import BlankLayout from "@/Layouts/BlankLayout"
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetButton from '@/Jetstream/Button'
//import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetForm from '@/Jetstream/Form'
import JetLabel from '@/Jetstream/Label'
import JiraGetStarted from '@/Components/Integrations/Jira/GetStarted'

export default {
    props: [
        'integration_type', // intercom, zendesk, helpscout, jira
        'integration', // for intercom only
        'details', 'redirect'
    ],


    components: {
        BlankLayout, JetInput, JetInputError, JetLabel,
        JetButton, JetForm, JiraGetStarted //JetActionMessage, // OptionsRadio,
        //JetDialogModal, JetSecondaryButton,

    },
    data() {
        return {
            form: this.$inertia.form({
                email: ""
            }),
            app_name: this.$page.props.app_name
        }
    },
    created() {
        if (this.integration_type == "intercom") {
            this.form.email = this.details.email
        } else if (this.integration_type == "zendesk") {
            this.form.email = this.details.agent_email
        } else if (this.integration_type == "helpscout") {
            this.form.email = this.details.mailbox_email
        } else if (this.integration_type == "freshchat" || this.integration_type == "freshdesk") {
            //let agent = JSON.parse(this.details.agent)
            //this.form.email = agent.email
        } else if (this.integration_type == "jira" && this.details.emailAddress) {
            this.form.email = this.details.emailAddress
        } else if (this.integration_type == "aircall") {
            // this.form.email = this.details.emailAddress
        } else if (this.integration_type == "salesforce") {
            this.form.email = this.details.sfemail
        } else if (this.integration_type == "hubspot") {
            this.form.email = this.details.agent_email
        }
    },
    beforeUnmount() {

    },
    mounted() {

    },
    computed: {
        is_complete() {
            return this.validateEmail(this.form.email)
        }
    },
    methods: {
        submitInstall() {
            let path = "/" + this.integration_type + "/install"
            this.form.get(path, {
                errorBag: 'submitInstall',
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
                onError: () => {
                    if (this.form.errors.email) {
                        this.form.reset('email')
                        this.$refs.email.focus()
                    }
                }
            })
        },
        validateEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validateNotempty(value) {
            var re = /^\s*\S+.*/;
            return re.test(value);
        }
    }
}
</script>

<style scoped>
.sidebar_gradient {
    background: -webkit-linear-gradient(#fafbfc, #e2e5e7);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}


.slide-fade-enter-active {
    transition: all .3s ease-out;
}

.slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
}
</style>
